export const IS_DEVELOPMENT = process.env.MODE === 'development'

export const DEFAULT_LOADING_IMAGE =
  'https://cdn.alpineiq.com/media/1/dda9d0b2-417c-4f04-a268-689e7ed451d0/default-loading.png'

export const LAYOUT = {
  padding: 24,
  gap: 32,
  contentGap: 16,
  buttonGap: 8,
  titleDescriptionGap: 8,
  loadingImageHeight: 300,
  navIconSize: 24,
} as const

export const AIQ_LOGO = {
  height: 9,
  width: 94,
  bottom: 4,
} as const

export const MOBILE_BREAKPOINTS = ['phone'] as const
